import i18n from 'scoreboard/components/i18n'
import * as urlToLinks from 'scoreboard/components/urls-to-links'
import globals from 'scoreboard/components/globals'
import config from 'scoreboard/components/config'

/**
 * Returns a message providing an example of the date format to use for imports.
 * Includes a link to a support article with import date documentation
 */

function dateFormatMessage() {
	let href = 'https://support.spiderstrategies.com/hc/en-us/articles/4417635051156-Import-Date-Parsing'
	let labelCode = 'admin.imports.instructions.dateFormat.supportArticle'
	let link = urlToLinks.createAnchor(href, labelCode)
	let dateFormat = config.dateFormat
	let dateExample = globals.dateExample
	let longDateExample = globals.longDateExample

	return i18n.get('admin.imports.instructions.dateFormat', dateFormat,
		longDateExample, dateExample, link)
}

export default dateFormatMessage
dateFormatMessage.__filename__ = 'imports/date-format-message.js'
